<template>
  <div>
    <div class="i-layout-page-header">
      <div class="i-layout-page-header">
        <Button icon="ios-arrow-back" size="small" class="mr20" @click="$router.go(-1)">返回</Button>
        <span class="ivu-page-header-title mr20" v-text="$route.meta.title"></span>
      </div>
    </div>
    <Card :bordered="false" dis-hover class="ivu-mt">
      <Form ref="formData" :model='formData' label-position="right" :label-width="200" :rules="ruleValidate"
            @submit.native.prevent>
        <Row :gutter="24" type="flex">

          <Col span="24">
            <FormItem label="专家照片" prop="expert_photo">
              <multi_upload ref="expertPhotoPic"></multi_upload>
            </FormItem>
          </Col>

          <Col span="24">
            <FormItem label="专家名称" prop="expert_name">
              <Input placeholder="请输入专家名称" class="perW30" v-model="formData.expert_name"></Input>
            </FormItem>
          </Col>

          <Col span="24">
            <FormItem label="专家类型" prop="type">
              <RadioGroup v-model="formData.type">
                <Radio :label="1">种植专家</Radio>
                <Radio :label="2">养牛专家</Radio>
                <Radio :label="3">养猪专家</Radio>
              </RadioGroup>
            </FormItem>
          </Col>

          <Col span="24">
            <FormItem label="手机号/账号" prop="phone">
              <Input placeholder="请输入手机号/账号" class="perW30" v-model="formData.phone"></Input>
            </FormItem>
          </Col>

          <Col span="24">
            <FormItem label="密码" prop="password">
              <Input placeholder="请输入密码" class="perW30" v-model="formData.password"></Input>
              <span style="color: #9b9b9b;margin-left: 10px;">密码长度为6-18位, 仅支持字母+数字, 添加新账户密码可不输入, 默认为123456</span>
            </FormItem>
          </Col>

          <Col span="24">
            <FormItem label="专家职位" prop="expert_job">
              <Input placeholder="请输入专家职位" class="perW60" v-model="formData.expert_job"></Input>
            </FormItem>
          </Col>

          <Col span="24">
            <FormItem label="擅长领域" prop="domain">
              <Input placeholder="请输入擅长领域" class="perW60" v-model="formData.domain"></Input>
            </FormItem>
          </Col>

          <Col span="24">
            <FormItem label="专家简介" prop="expert_profile">
              <Input type="textarea" :autosize="{minRows: 5,maxRows: 10}" placeholder="请输入专家简介" class="perW60"
                     v-model="formData.expert_profile"></Input>
            </FormItem>
          </Col>

          <Col span="24">
            <FormItem label="详细介绍" prop="detail">
              <ueditor ref="expertDetailContents" :content="formData.detail"></ueditor>
            </FormItem>
          </Col>

        </Row>

        <FormItem>
          <Button type="primary" class="submission" @click="submit">提交</Button>
        </FormItem>

      </Form>
    </card>

  </div>
</template>
<script>
import {expertSaveApi, expertInfoApi} from '@/api/expert/expert'
import multi_upload from '_c/multi_upload'
import ueditor from '@/components/ueditorFrom/index'
import {imgFormat} from "_c/common/imgFormat";

export default {
  name: 'expertEdit',
  components: {multi_upload, ueditor},
  data() {
    return {
      formData: {
        expert_id: 0,
        type: 1,
        expert_photo: '',
        expert_name: '',
        phone: '',
        password: '',
        expert_job: '',
        domain: '',
        expert_profile: '',
        detail: '',
      },
      ruleValidate: {
        expert_photo: [
          {required: true, message: '请上传专家照片', trigger: 'blur'}
        ],
        expert_name: [
          {required: true, message: '请输入专家名称', trigger: 'blur'}
        ],
        type: [
          {required: true, type: 'number', message: '请选择专家类型', trigger: 'blur'}
        ],
        phone: [
          {required: true, message: '请输入手机号', trigger: 'blur'}
        ],
        password: [
          {required: false, min: 6, max: 18, message: '请输入6-18位密码', trigger: 'blur'}
        ],
        expert_job: [
          {required: true, message: '请输入专家职位', trigger: 'blur'}
        ],
        domain: [
          {required: true, message: '请输入擅长领域', trigger: 'blur'}
        ],
        expert_profile: [
          {required: true, message: '请输入专家简介', trigger: 'blur'}
        ],

      },
    }
  },
  mounted() {
    if (this.$route.params.id !== '0' && this.$route.params.id) {
      this.loadFormData(this.$route.params.id)
    }
  },
  methods: {
    //提交数据
    submit() {

      // 单图获取
      if (this.$refs.expertPhotoPic.uploadPics.length > 0) {
        this.formData.expert_photo = this.$refs.expertPhotoPic.uploadPics[0].url;
      } else {
        this.formData.expert_photo = ''
      }

      // 富文本内容获取
      this.formData.detail = this.$refs.expertDetailContents.contents

      // 验证数据
      this.$refs.formData.validate((valid) => {
        if (!valid) {
          this.$Message.error('请检查输入内容!')
          return false
        } else {
          //请求接口
          expertSaveApi(this.formData).then(res => {
            if (res.code === 200) {
              this.$Message.success('成功')
              setTimeout(() => {
                this.$router.go(-1)
              }, 500)
            } else {
              this.$Message.error(res.msg)
            }
          }).catch(res => {
            this.$Message.error(res.msg)
          })
        }
      })

    },

    // 编辑加载数据
    loadFormData(id) {
      expertInfoApi(id).then(res => {
        //数据赋值
        this.formData = res.data

        // 图片赋值
        if (this.formData.expert_photo) {
          this.$refs.expertPhotoPic.uploadPics = [];
          this.$refs.expertPhotoPic.uploadPics.push(imgFormat(this.formData.expert_photo))
        }

        // 富文本内容赋值
        this.$refs.expertDetailContents.contents = this.formData.detail

      }).catch(res => {
        this.$Message.error(res.msg)
      })
    },

  }
}
</script>
